import { Injectable } from '@angular/core';
import { TamanhoGrade } from 'src/app/models/api/dados-especificos/tamanho-grade';
import { ApiHttpClientService } from '../../api-http-client.service';
import { IResponse } from 'src/app/models/api/response.interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ApiTamanhoGradeService {

  private baseUrl = 'TamanhoGrades';
  private controller: ApiHttpClientService;

  constructor(
    private api: ApiHttpClientService
  ) {
    this.controller = this.api
      .useBaseUrl(environment.microservice.dadosEspecificos)
      .useBaseUrl(this.baseUrl);
  }

  getAll() {
    return this.controller.get<IResponse<TamanhoGrade[]>>('');
  }
}
